module.exports = __webpack_public_path__ + "static/media/user-cog.806e86bd.svg";